import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Customer, CustomerForm, Page, IdName } from '../models';

@Injectable()
export class CustomerService {

  customersUrl = environment.dns + 'api/customers/';

  constructor(private http: HttpClient) { }

  getPaginate(page: number, size: number): Observable<Page<Customer>> {
    return this.http.get<Page<Customer>>(this.customersUrl + 'paginate?page=' + page + '&size=' + size);
  }

  getList(): Observable<Customer[]> {
    return this.http.get<Customer[]>(this.customersUrl + 'list');
  }

  getRevendeurs(): Observable<Customer[]> {
    return this.http.get<Customer[]>(this.customersUrl + 'list/revendeurs');
  }

  getOne(id: number): Observable<Customer> {
    return this.http.get<Customer>(this.customersUrl + id);
  }

  add(customerForm: CustomerForm): Observable<Customer> {
    return this.http.post<Customer>(this.customersUrl, customerForm);
  }

  update(customerForm: CustomerForm): Observable<Customer> {
    return this.http.put<Customer>(this.customersUrl, customerForm);
  }

  delete(id: number): Observable<boolean> {
    return this.http.delete<boolean>(this.customersUrl + id);
  }

  searchMin(q: string, page = 0, size = 20): Observable<Page<IdName>> {
    return this.http.get<Page<IdName>>(this.customersUrl + 'search?q=' + encodeURIComponent(q || '') + '&page=' + page + '&size=' + size);
  }
}
